import { Box, Button, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import logo from "./images/logo.svg";
import { useRef } from "react";
import { useVisualViewportHeight } from "../../../lib/useVisualViewportHeight";
import {
  ScreenTransitioner,
  ScreenTransitionerHandle,
} from "../../../components/ScreenTransitioner/ScreenTransitioner";
import { AuthenticationForm } from "../../../components/AuthenticationDialog/AuthenticationForm";
import { ScreenTransitionDirection } from "../../../components/ScreenTransitioner/ScreenTransitionDirection";

export const LoggedOut = () => {
  const navigate = useNavigate();
  const screenTransitionerRef = useRef<ScreenTransitionerHandle>(null);
  const viewportHeight = useVisualViewportHeight();
  console.log({ viewportHeight });
  return (
    <ScreenTransitioner
      ref={screenTransitionerRef}
      width="100%"
      screens={{
        splash: (
          <Box
            padding="2rem"
            paddingTop="calc(env(safe-area-inset-top) + 2rem)"
            paddingBottom="calc(env(safe-area-inset-bottom) + 2rem)"
            paddingLeft="calc(env(safe-area-inset-left) + 2rem)"
            paddingRight="calc(env(safe-area-inset-right) + 2rem)"
            minHeight="100dvh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
          >
            <Box flex={1} display="flex">
              <Image src={logo} alt="" />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              paddingX="2rem"
              width="100%"
              gap="0.5rem"
            >
              <Button
                variant="solid"
                onClick={() =>
                  screenTransitionerRef.current?.setIndex("signUp", {
                    direction: ScreenTransitionDirection.Right,
                  })
                }
              >
                Sign Up
              </Button>
              <Button
                variant="ghost"
                onClick={() =>
                  screenTransitionerRef.current?.setIndex("signIn", {
                    direction: ScreenTransitionDirection.Right,
                  })
                }
              >
                Sign In
              </Button>
            </Box>
          </Box>
        ),
        signIn: (
          <Box
            padding="2rem"
            paddingTop="calc(env(safe-area-inset-top) + 2rem)"
            paddingBottom="calc(env(safe-area-inset-bottom) + 2rem)"
            paddingLeft="calc(env(safe-area-inset-left) + 2rem)"
            paddingRight="calc(env(safe-area-inset-right) + 2rem)"
            height={`${viewportHeight}px`}
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
          >
            <AuthenticationForm
              confirmLabel="Sign in"
              onComplete={() => {
                navigate("/events");
              }}
              onClose={() =>
                screenTransitionerRef.current?.setIndex("splash", {
                  direction: ScreenTransitionDirection.Left,
                })
              }
            />
          </Box>
        ),
        signUp: (
          <Box
            padding="2rem"
            paddingTop="calc(env(safe-area-inset-top) + 2rem)"
            paddingBottom="calc(env(safe-area-inset-bottom) + 2rem)"
            paddingLeft="calc(env(safe-area-inset-left) + 2rem)"
            paddingRight="calc(env(safe-area-inset-right) + 2rem)"
            height={`${viewportHeight}px`}
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
          >
            <AuthenticationForm
              confirmLabel="Sign up"
              onComplete={() => {
                navigate("/events");
              }}
              onClose={() =>
                screenTransitionerRef.current?.setIndex("splash", {
                  direction: ScreenTransitionDirection.Left,
                })
              }
            />
          </Box>
        ),
      }}
      startIndex="splash"
    />
  );
};
